import { useT } from "../lib/i18n";

export function Problem() {
  const t = useT();

  return (
    <section
      id="problem"
      className="border-t border-margin dark:border-paper/10 bg-margin/20 dark:bg-paper/[0.02]"
    >
      <div className="mx-auto max-w-3xl px-6 py-24">
        <h2 className="font-display text-3xl sm:text-4xl font-semibold tracking-tight text-ink dark:text-paper leading-tight">
          {t.problem.heading}
        </h2>
        <p className="mt-8 text-lg text-ink/75 dark:text-paper/75 leading-relaxed">
          {t.problem.body1}
        </p>
        <p className="mt-6 text-lg text-ink/75 dark:text-paper/75 leading-relaxed">
          {t.problem.body2}
        </p>
      </div>
    </section>
  );
}
